import enCompanyProfile from './en';
import ruCompanyProfile from './ru';

export default {
  en: {
    ...enCompanyProfile,
  },
  ru: {
    ...ruCompanyProfile,
  },
};
